export enum CreateRequestMode {
  Full = 0,
  //previously there was a PreventativeMaintenance mode which has been removed (XOSPHERE-2775)
}
